import differenceInDays from "date-fns/differenceInDays";
import parseISO from "date-fns/parseISO";
import endOfToday from "date-fns/endOfToday";

export const getDaysAmountToExpirationDate = (
  expirationDate: string,
  targetDate: number | Date = endOfToday()
): number => differenceInDays(parseISO(expirationDate), targetDate);
